var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22C26.3125 22 31.4286 17.0758 31.4286 11C31.4286 4.92422 26.3125 0 20 0C13.6875 0 8.57143 4.92422 8.57143 11C8.57143 17.0758 13.6875 22 20 22ZM28 24.75H26.5089C24.5268 25.6266 22.3214 26.125 20 26.125C17.6786 26.125 15.4821 25.6266 13.4911 24.75H12C5.375 24.75 0 29.9234 0 36.3V39.875C0 42.1523 1.91964 44 4.28571 44H35.7143C38.0804 44 40 42.1523 40 39.875V36.3C40 29.9234 34.625 24.75 28 24.75Z",
    fill: "#075985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/Student.63667e639676b0dac14406dd6af07845.svg";
export { ForwardRef as ReactComponent };